import type { TResponseFormatData } from '../../models/data';
import type { TMapFields } from '../../models';

import { pipe, formatDate, transformFields, pickFieldForArchivarius } from './helpers';

/**
 * Преобразует номер телефона, удаляет все кроме чисел, а также удаляет маску
 * @param phone - номер телефона
 * @example +7 (901) 123-32-12 => 9011233212
 */
const formatPhoneValue = (phone: string) => {
    const regexp = new RegExp(/^\+7?|\D/, 'g');

    return phone.replace(regexp, '');
};

/** Преобразует номер телефона в объекте из формы */
const preparePhoneValue = (data: TResponseFormatData) => {
    const { phone } = data;

    if (!phone) return data;

    return { ...data, phone: formatPhoneValue(phone) };
};

/** Адаптирует данные из формы под формат данных сервера */
export const formatClientData = (data: TResponseFormatData, mapField: TMapFields) =>
    pipe(
        // Синхронизируем поля с клиента с полями на бэке
        transformFields(mapField),
        // Форматируем дату в формат бэка
        formatDate('toServer'),
        // Форматируем номер телефона
        preparePhoneValue,
        // Оставляем только поля архивариуса
        pickFieldForArchivarius
    )(data);
